import * as React from "preact";
import { render } from "preact";

import App from "./App";

function init() {
  const widgets = document.querySelectorAll<HTMLElement>(".factset-widget");

  widgets.forEach(el => {
    const id = el.id;
    const { investmentId, publicationDate, includeEsg, widgetType } = el.dataset;
    console.log(investmentId);
    if (investmentId) {
      render(
        <App
          investmentId={investmentId}
          publicationDate={publicationDate}
          includeEsg={includeEsg}
          widgetType={widgetType}
          instanceId={id}
        />,
        el
      );
    }
  })
}

export default { init };
